exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___2D-B- {\n  margin-top: -40px;\n  margin-bottom: -50px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___2D-B-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/RegistryOnboardContainer.module.less
// module id = 2043
// module chunks = 51